/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NascarProjectionsTableQueryVariables = {|
  series: string
|};
export type NascarProjectionsTableQueryResponse = {|
  +whoAmI: ?{|
    +groups: $ReadOnlyArray<{|
      +name: string
    |}>,
    +username: string,
  |},
  +nascarProjectionHeaders: ?$ReadOnlyArray<?{|
    +headerName: string,
    +headerSlug: string,
    +sortDescFirst: boolean,
  |}>,
  +nascarProjectionRow: ?$ReadOnlyArray<?{|
    +rowJson: any
  |}>,
|};
export type NascarProjectionsTableQuery = {|
  variables: NascarProjectionsTableQueryVariables,
  response: NascarProjectionsTableQueryResponse,
|};
*/


/*
query NascarProjectionsTableQuery(
  $series: String!
) {
  whoAmI {
    groups {
      name
    }
    username
    id
  }
  nascarProjectionHeaders(series: $series) {
    headerName
    headerSlug
    sortDescFirst
    id
  }
  nascarProjectionRow(series: $series) {
    rowJson
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "series"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "GroupType",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "series",
    "variableName": "series"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerSlug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortDescFirst",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowJson",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NascarProjectionsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NascarProjectionHeadersType",
        "kind": "LinkedField",
        "name": "nascarProjectionHeaders",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NascarProjectionRowType",
        "kind": "LinkedField",
        "name": "nascarProjectionRow",
        "plural": true,
        "selections": [
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NascarProjectionsTableQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserType",
        "kind": "LinkedField",
        "name": "whoAmI",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NascarProjectionHeadersType",
        "kind": "LinkedField",
        "name": "nascarProjectionHeaders",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NascarProjectionRowType",
        "kind": "LinkedField",
        "name": "nascarProjectionRow",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d1630d26d110a58d47e8ba7160f9982",
    "id": null,
    "metadata": {},
    "name": "NascarProjectionsTableQuery",
    "operationKind": "query",
    "text": "query NascarProjectionsTableQuery(\n  $series: String!\n) {\n  whoAmI {\n    groups {\n      name\n    }\n    username\n    id\n  }\n  nascarProjectionHeaders(series: $series) {\n    headerName\n    headerSlug\n    sortDescFirst\n    id\n  }\n  nascarProjectionRow(series: $series) {\n    rowJson\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f97a69f032f4dea50af6bd2eee3bade5';

module.exports = node;
